export default __webpack_public_path__ + "static/media/hirect.8992416f.svg";